"use strict";import{IconChevron100 as e}from"../src/elements/IconChevron100.js";import{defineElement as o}from"@spectrum-web-components/base/src/define-element.js";o("sp-icon-chevron100",e);
//# sourceMappingURL=sp-icon-chevron100.js.map
